import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export function WizardStepKPIs({ form, updateKpi, addKpi, removeKpi }) {
  return (
    <div className="space-y-4" data-testid="wizard-step-kpis-content">
      <div>
        <h2 className="text-lg font-medium">Key Performance Indicators</h2>
        <p className="text-sm text-slate-500 mt-1">How will you measure supplier performance? These will be tracked in the Management section.</p>
      </div>
      <div className="space-y-2">
        {form.kpis.map((k, i) => (
          <div key={`kpi-${i}`} className="flex gap-2 items-start">
            <span className="w-6 h-8 flex items-center justify-center text-xs text-slate-400 shrink-0">{i + 1}.</span>
            <Input value={k.description} onChange={e => updateKpi(i, "description", e.target.value)} placeholder="e.g., System uptime" className="rounded-sm flex-1" data-testid={`wizard-kpi-${i}`} />
            <Input value={k.measure} onChange={e => updateKpi(i, "measure", e.target.value)} placeholder="e.g., 99.9% monthly" className="rounded-sm flex-1" />
            {form.kpis.length > 1 && (
              <Button variant="ghost" size="icon" className="h-9 w-9 text-red-400" onClick={() => removeKpi(i)}>x</Button>
            )}
          </div>
        ))}
      </div>
      <Button variant="outline" size="sm" onClick={addKpi} className="rounded-sm gap-1.5" data-testid="wizard-add-kpi">+ Add KPI</Button>
      <p className="text-xs text-slate-400">Tip: KPIs help the system guide you on what to track once the contract is active.</p>
    </div>
  );
}
